export const darkTheme = { 
    bgColor: "#000300",
    midColor: "#004992", 
    textColor: "#fff",
}


export const lightTheme = { 
    bgColor: "#91C8E4",
    midColor: "#F6F4EB", 
    textColor: "#000000e",
}


